import React from "react";
import { Link } from "react-router-dom";
import "./movieListItem.scss";
import { connect } from "react-redux";
import {
  fetchFavoriteMovie,
  removeFromFavorite
} from "../../store/favorites/actions";
import { genres } from "./genres";

const MovieListItem = ({
  id,
  title,
  genre_ids,
  poster_path,
  addToFavorite,
  removeFromFavorite,
  favorites
}) => {
  const checkIsFavorite =
    favorites.findIndex(elem => elem.id === id) > -1 ? (
      <img
        className="movie-favorites has-favorite"
        src="https://image.flaticon.com/icons/png/512/148/148836.png"
        alt="add to favorites"
        onClick={() => removeFromFavorite(id)}
      />
    ) : (
      <img
        className="movie-favorites"
        src="https://image.flaticon.com/icons/png/512/148/148836.png"
        alt="add to favorites"
        onClick={() => addToFavorite(id)}
      />
    );

  const genresNames = genre_ids
    ? genres.filter(it => genre_ids.includes(it.id))
    : [];

  return (
    <div className="movie-item">
      <Link to={`/details/${id}`}>
          <img
            className="movie-poster"
            src={`https://image.tmdb.org/t/p/w500/${poster_path}`}
            alt="poster"
          />
      </Link>
      <div className="body-wrap">
        <Link className="title-link" to={`/details/${id}`}>
          <div className="movie-title">{title}</div>
        </Link>
        {checkIsFavorite}
        <div className="movie-genre">
          {genresNames.slice(0, 2).map((item, i) => {
            return (
              <div className="genre-item" key={item.id}>
                {item.name}/
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapState = state => {
  return {
    favorites: state.favorites.favorites
  };
};

const mapDispatch = dispatch => {
  return {
    addToFavorite: id => fetchFavoriteMovie(dispatch, id),
    removeFromFavorite: id => removeFromFavorite(dispatch, id)
  };
};

export default connect(mapState, mapDispatch)(MovieListItem);
